// @ts-nocheck

(function () {
  const logo = document.getElementById('hero-logo-animated');
  if (!logo) return;

  function isMobile() { return window.innerWidth < 750; }
  function vw() { return window.innerWidth / 100; }
  function lerp(a, b, t) { return a + (b - a) * t; }

  function getHeaderHeight() {
    const h = document.querySelector('.cc-header');
    return h ? h.getBoundingClientRect().height : 60;
  }

  function getEndPosition() {
    const headerH = getHeaderHeight();
    return { x: window.innerWidth / 2, y: headerH / 2 };
  }

  function getStartPosition() {
    const hero = document.querySelector('.custom-hero');
    if (!hero) return { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const r = hero.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }

  function update() {
    const mobile = isMobile();
    const START_VW = mobile ? 90.513 : 51.667;
    const END_VW = mobile ? 28.462 : 9.861;

    const heroRect = document.querySelector('.custom-hero')?.getBoundingClientRect();
    if (!heroRect) return;

    const headerH = getHeaderHeight();
    const heroCenter = heroRect.top + heroRect.height / 2;
    const screenMid = window.innerHeight / 2;

    let progress = (screenMid - heroCenter) / (screenMid - headerH / 2);
    progress = Math.min(Math.max(progress, 0), 1);

    const currentW = lerp(START_VW, END_VW, progress) * vw();
    const currentH = currentW * (319 / 744);

    const start = getStartPosition();
    const end = getEndPosition();

    const x = lerp(start.x, end.x, progress);
    const y = lerp(start.y, end.y, progress);

    logo.style.position = 'fixed';
    logo.style.width = currentW + 'px';
    logo.style.height = currentH + 'px';
    logo.style.left = (x - currentW / 2) + 'px';
    logo.style.top = (y - currentH / 2) + 'px';
    logo.style.opacity = '1';
    logo.style.zIndex = '1001';

    // const header = document.querySelector('.cc-header');
    // const isDark = header ? header.classList.contains('cc-header--dark') : false;
    // const paths = logo.querySelectorAll('path');
    // paths.forEach(p => p.setAttribute('fill', isDark ? '#203024' : 'white'));

    // METTI questo:
    const header = document.querySelector('.cc-header');
    const isDark = header ? header.classList.contains('cc-header--dark') : false;
    const logoBianco = logo.querySelector('.logoBianco');
    const logoNero = logo.querySelector('.logoNero');
    if (logoBianco) logoBianco.style.opacity = isDark ? '0' : '1';
    if (logoNero) logoNero.style.opacity = isDark ? '1' : '0';
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  requestAnimationFrame(update);

})();


